/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMagnifyingGlassMinus: {
  name: 'magnifying-glass-minus';
  data: string;
} = {
  name: 'magnifying-glass-minus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 1.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM.5 7a6.5 6.5 0 1 1 11.436 4.23l3.418 3.416a.5.5 0 0 1-.708.708l-3.417-3.418A6.5 6.5 0 0 1 .5 7Zm4 0a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
